export default {"src":"/_next/static/media/Checklist.16482d7c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};